/**
 * Step 3B: プロフィール入力ステップ
 *
 * サブステップ: Gender → Birthday → Favorites → IconPreview
 *
 * フッターは親（CreateUserWizard）で管理
 */
import { GenerationStatus } from "features/generation/types";
import { GenderStep } from "./GenderStep";
import { BirthdayStep } from "./BirthdayStep";
import { FavoritesStep } from "./FavoritesStep";
import { IconPreviewStep } from "./IconPreviewStep";
import { ProfileSubStepBar } from "../../components/ProfileSubStepBar";
import { CreateUserState, ProfileSubStep, FavoritesSubStep, UserType } from "../../types";

interface ProfileAIStepProps {
  state: CreateUserState;
  updateState: (updates: Partial<CreateUserState>) => void;
  userType: UserType;
  currentSubStep: ProfileSubStep;
  generationStatus: GenerationStatus;
  generationProgress: number;
  generatedImage: string | null;
  partialImage: string | null;
  // FavoritesStep 用の状態（親から管理）
  favoritesSubStep: FavoritesSubStep;
  // サブステップ遷移用コールバック
  onSubStepNext?: () => void;
  // サブステップクリック時のコールバック
  onSubStepClick?: (profileSubStep: ProfileSubStep, favoritesSubStep?: FavoritesSubStep) => void;
  // サブステップバーを非表示にする
  hideSubStepBar?: boolean;
  // 入力済みステップのIDリスト（ProfileSubStepBarに渡す）
  completedStepIds?: string[];
  // 追加プロンプト関連
  additionalPrompt?: string;
  onAdditionalPromptChange?: (prompt: string) => void;
  onRegenerate?: () => void;
}

export const ProfileAIStep = ({
  state,
  updateState,
  userType,
  currentSubStep,
  generationStatus,
  generationProgress,
  generatedImage,
  partialImage,
  favoritesSubStep,
  onSubStepClick,
  hideSubStepBar = false,
  completedStepIds,
  additionalPrompt,
  onAdditionalPromptChange,
  onRegenerate,
}: ProfileAIStepProps) => {
  const stepProps = { state, updateState, userType };

  // サブステップコンテンツを表示
  const renderContent = () => {
    switch (currentSubStep) {
      case ProfileSubStep.GENDER:
        return <GenderStep {...stepProps} />;
      case ProfileSubStep.BIRTHDAY:
        return <BirthdayStep {...stepProps} />;
      case ProfileSubStep.FAVORITES:
        return <FavoritesStep {...stepProps} favoritesSubStep={favoritesSubStep} />;
      case ProfileSubStep.ICON_PREVIEW:
        return (
          <IconPreviewStep
            status={generationStatus}
            progress={generationProgress}
            generatedImage={generatedImage}
            partialImage={partialImage}
            additionalPrompt={additionalPrompt}
            onAdditionalPromptChange={onAdditionalPromptChange}
            onRegenerate={onRegenerate}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex-row-el w-full h-full gap-4">
      {/* サブステップ進捗バー（左側） */}
      {!hideSubStepBar && (
        <ProfileSubStepBar
          currentSubStep={currentSubStep}
          favoritesSubStep={favoritesSubStep}
          onStepClick={onSubStepClick}
          completedStepIds={completedStepIds}
        />
      )}

      {/* コンテンツ（右側・中央揃え） */}
      <div className="flex-col-el flex-center flex-1 min-h-0 bg-white border-4 border-[#c2c9cf] rounded-3xl">
        {renderContent()}
      </div>
    </div>
  );
};
